export const getProcessStatementRtf = (state) => state.tempStore.rtfTemplate || '';
